/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GiftCardBalanceResultModel from './GiftCardBalanceResultModel';

/**
* The GiftCardReloadResultModel model module.
* @module model/GiftCardReloadResultModel
* @version 1.0.0
*/
export default class GiftCardReloadResultModel {
    /**
    * Constructs a new <code>GiftCardReloadResultModel</code>.
    * @alias module:model/GiftCardReloadResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>GiftCardReloadResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GiftCardReloadResultModel} obj Optional instance to populate.
    * @return {module:model/GiftCardReloadResultModel} The populated <code>GiftCardReloadResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GiftCardReloadResultModel();
                        
            
            if (data.hasOwnProperty('ChargeDateUtc')) {
                obj['ChargeDateUtc'] = ApiClient.convertToType(data['ChargeDateUtc'], 'Date');
            }
            if (data.hasOwnProperty('ReloadAmount')) {
                obj['ReloadAmount'] = ApiClient.convertToType(data['ReloadAmount'], 'Number');
            }
            if (data.hasOwnProperty('Card')) {
                obj['Card'] = GiftCardBalanceResultModel.constructFromObject(data['Card']);
            }
        }
        return obj;
    }

    /**
    * @member {Date} ChargeDateUtc
    */
    'ChargeDateUtc' = undefined;
    /**
    * @member {Number} ReloadAmount
    */
    'ReloadAmount' = undefined;
    /**
    * @member {module:model/GiftCardBalanceResultModel} Card
    */
    'Card' = undefined;




}
